"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Client = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _prismicJavascript = _interopRequireDefault(require("prismic-javascript"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Client = function Client() {
  var req = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return new PrismicClient().getClient();
};
exports.Client = Client;
var PrismicClient = /*#__PURE__*/function () {
  function PrismicClient() {
    (0, _classCallCheck2["default"])(this, PrismicClient);
    if (!PrismicClient.instance) {
      PrismicClient.instance = _prismicJavascript["default"].client(global.__appConfig__.prismicEndpointUrl, this.createClientOptions(null, global.__appConfig__.prismicToken));
    }
  }
  (0, _createClass2["default"])(PrismicClient, [{
    key: "createClientOptions",
    value: function createClientOptions() {
      var req = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var prismicAccessToken = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var prismicTimeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : global.__appConfig__.prismicTimeout;
      var reqOption = req ? {
        req: req
      } : {};
      var accessTokenOption = prismicAccessToken ? prismicTimeout ? {
        accessToken: prismicAccessToken,
        timeoutInMs: prismicTimeout
      } : {
        accessToken: prismicAccessToken
      } : prismicTimeout ? {
        timeoutInMs: prismicTimeout
      } : {};
      return _objectSpread(_objectSpread({}, reqOption), accessTokenOption);
    }
  }, {
    key: "getClient",
    value: function getClient() {
      return PrismicClient.instance;
    }
  }]);
  return PrismicClient;
}();